// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"f9381cb559e9a010467c","303":"67337e8ee6e18621354d","495":"f7fc994c98a2172a79fc","826":"f63a74c4a62eb602bb33","946":"8422f15b87321eb025f7"}[chunkId] + ".js";
};